import { Product } from '@core/models/piramide/Product';
import { ProductInCompatibility } from '@core/services/CompatibilityHandler/productInCompatibility';
import { FiltroBotones } from '@core/models/filtroBotones';

export abstract class Paso {
  //DEUDA LINGUISTICA
  productoSeleccionado: ProductInCompatibility<Product>[] = [];
  lista_productos: ProductInCompatibility<Product>[];
  productoUnico: boolean;
  tipo: string;
  paso: number;
  descripcion: string;
  img_noselect: string;
  img_select: string;
  lleno: boolean;
  seleccionado: boolean = false;
  visitado: boolean;
  filtros: FiltroBotones[];
  sort: string;
  permitidoSinCompatibilidad: boolean = false;
  static pasos: Paso[] = [];

  estoyParcial(): boolean {
    return !!this.productoSeleccionado.length;
  }
  public limpiarCantidades() {
    this.lista_productos.forEach((producto) => {
      producto.cantidad = 0;
    });
  }
  public ordenarFiltros() {
    this.filtros.sort((a, b) => a.nombre.localeCompare(b.nombre));
  }
  public deseleccionarFiltros() {
    this.filtros.forEach((f) => (f.seleccionado = false));
  }
  constructor(
    unico,
    tipo,
    descripcion,
    paso,
    img_noselect,
    img_select,
    permitidoSinCompatibilidad,
    filtros,
    sort?,
  ) {
    this.sort = sort ?? '';
    this.productoUnico = unico;
    this.tipo = tipo;
    this.descripcion = descripcion;
    this.paso = paso;
    this.img_noselect = img_noselect;
    this.img_select = img_select;
    this.permitidoSinCompatibilidad = permitidoSinCompatibilidad;
    this.filtros = filtros;
    Paso.pasos.push(this);
    this.deseleccionarFiltros();
  }
}
